/** Hilfen rund um Seriendruckfelder – sie sind gewöhnliche Word-Felder. */

import { unsupported } from "@/core/check";
import type { CheckResult } from "@/core/types";
import { type FieldInfo, readFields } from "@/office/word/layout";

export const FELDER_NICHT_LESBAR: CheckResult = unsupported(
  "Diese Word-Version stellt dem Add-in keine Felder zur Verfügung (ab WordApi 1.4), " +
    "deshalb lassen sich die Seriendruckfelder hier nicht prüfen.",
  "Mit Alt + F9 werden die Feldfunktionen sichtbar – ein Seriendruckfeld erscheint als " +
    "{ MERGEFIELD … }. Danach kannst du den Schritt selbst als erledigt markieren.",
);

/** Felder, deren Code mit einem der Schlüsselwörter beginnt. */
export function felderMit(felder: FieldInfo[], ...schluessel: string[]): FieldInfo[] {
  const muster = new RegExp(`^(${schluessel.join("|")})\\b`, "i");
  return felder.filter((feld) => muster.test(feld.code));
}

/** Namen der eingefügten Seriendruckfelder, z. B. ["Vorname", "Nachname"]. */
export function seriendruckFeldnamen(felder: FieldInfo[]): string[] {
  const namen = felderMit(felder, "MERGEFIELD").map(
    (feld) => /^MERGEFIELD\s+"?([^"\s\\]+)"?/i.exec(feld.code)?.[1] ?? "",
  );
  return [...new Set(namen.filter((name) => name.length > 0))];
}

export { readFields };
